export default __webpack_public_path__ + "2bc8c36726efcbd27f3c23de9193852c.png";